import React, {Fragment} from "react";
import {PageHeader} from "../PageHeader";
import {useContent} from "../../customHooks/useContent";
import content from "../../content/schoolOverview.json";
import ReactHtmlParser from 'react-html-parser';
import "./summer_school.css";
import {generateRandomKey} from "../../utils/generateRandomKey";
import AS from '../../images/Soltysiak.jpg';
import ASm from '../../images/mobile/Soltysiak.jpg';
import JH from '../../images/Javad_Hosseinzadeh.jpg';
import JHm from '../../images/mobile/Javad_Hosseinzadeh.jpg';
import {initEstarkMap} from "../../maps/initEstarkMap";
import {Map} from "../Map";

export const SchoolOverview = () => {
    const text = useContent(content);

    const generateSectionContent = (sectionContent) => {
        return (
            <section className="col-12">
                <h2>{sectionContent.header}</h2>
                {sectionContent.paragraphs.map(paragraph => <p key={generateRandomKey()}>{ReactHtmlParser(paragraph)}</p>)}
                {/*{sectionContent.header.includes("Estark") && <div id="EstarkMap" className="map"></div>}*/}
            </section>
        )
    };

    const generateLeadersSection = (sectionContent) => {
        sectionContent.list[0] = {...sectionContent.list[0], photo: JH, smallPhoto: JHm};
        sectionContent.list[1] = {...sectionContent.list[1], photo: AS, smallPhoto: ASm};

      return (
          <section className="col-12">
              <h2>{sectionContent.header}</h2>
              {sectionContent.list.map(leader => (
                  <div key={generateRandomKey()}>
                      <p><b>{leader.name}</b> ({leader.school})</p>
                      <p>{ReactHtmlParser(leader.bio)}</p>
                      <div className={leader.name.includes('Javad') ? 'photo-in-paragraph vertical' : 'photo-in-paragraph'}>
                          <img src={leader.photo}
                               srcSet={`${leader.smallPhoto} 900w, ${leader.photo} 1500w`}
                               className="img-fluid" alt={leader.name}/>
                      </div>
                  </div>
                ))}
          </section>
      )
    };

    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass="header-school-overview"/>
            <main>
                <div className="container">
                    <div className="row">
                        {text.intro && generateSectionContent(text.intro)}
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        {text.leaders && generateLeadersSection(text.leaders)}
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        {text.estark && generateSectionContent(text.estark)}
                        <div id="EstarkMap" className="map">
                            <Map mapData={initEstarkMap} />
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        {text.kashan && generateSectionContent(text.kashan)}
                    </div>
                </div>
            </main>

        </Fragment>
    )
};
